import { styled } from '@mui/material/styles';

export const NavbarStyled = styled('nav')`
  width: 100%;
  background-color: #fff;
  padding: 0 0.5rem;
`;
